import type { ParseCookiesContext } from '@/utils/cookies';
import { useQuery } from '@tanstack/react-query';
import { FPGoal } from '../../interface/Goal';
import { setupApiClient } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useGetFPGoals = () =>
  useQuery({
    queryKey: ['financial-planning', 'goals'],
    queryFn: () => getFPGoals(),
  });

export const getFPGoals = async (context?: ParseCookiesContext) => {
  const api = setupApiClient(context, true);
  const { data } = await api.get<FPGoalResponse>(
    apiConfig.routes.financialPlanning.goals.goals
  );
  return data?.goalList;
};

type FPGoalResponse = {
  goalList: FPGoal[];
};
